import { render } from "./ProjectAdvertBanner.vue?vue&type=template&id=70da3358"
import script from "./ProjectAdvertBanner.vue?vue&type=script&lang=js"
export * from "./ProjectAdvertBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__